import { ClassProvider, InjectionToken } from '@angular/core';

export interface ScannerConfig<T = void> {
  adapter: ClassProvider;
  scanFrequency?: number;
  adapterConfig?: T;
}

export const SCANNER_CONFIG = new InjectionToken<ScannerConfig>('ScannerConfig');
